import * as types from './action-types'

export const fetchEmployerShiftRateTypes = (employerId: number) => ({
  type: types.EMPLOYER_SHIFT_RATE_TYPES_FETCH_BEGIN,
  payload: {
    employerId,
  },
})
